import BaseService from '../BaseService';

class FaqAreasService extends BaseService {
    constructor() {
        super('/programas/faq-areas/');
    }
}

export default new FaqAreasService();
